import React, {useState} from "react";
import SelectSearch from 'react-select-search';

const ReactSelectTime = ({
                             refTime,
                         }) => {
    const [refTIme, setRefTime] = useState("")
    const [reactSelectClassname, setReactSelectClassname] = useState("")
    const timeOptions = [
        {value: "9h/12h", name: 'Entre 9h et 12h'},
        {value: "12h/14h", name: 'Entre 12h et 14h'},
        {value: "14h/17h", name: 'Entre 14h et 17h'},
        {value: "17h/19h", name: 'Entre 17h et 19h'}
    ]
    // console.log("timeoption", timeOptions)
    return (
        <>
            <div className={`input-container ${reactSelectClassname}`} id={"react-select"}>
                <SelectSearch
                    options={timeOptions}
                    value={timeOptions.name}
                    // name="language"
                    placeholder=" "
                    search
                    ref={refTime}
                    onFocus={() => {
                        let value = timeOptions.name
                        setReactSelectClassname("active")
                        console.log("ref", timeOptions.name, "select", SelectSearch)
                    }}
                    // onChange={() => console.log("test4", SelectSearch)}
                    onBlur={() => {
                        let value = timeOptions.name
                        setReactSelectClassname("active")
                        console.log("ref", timeOptions.name, "select", SelectSearch)
                    }}
                    // autoComplete={"on"}
                />
                <div className={"placeholder"}>
                    <p className={reactSelectClassname}>Créneau horaire *</p>
                </div>

            </div>
        </>
    );
}
export default ReactSelectTime;